import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'
import { spacing } from '@mobi/component-library/Foundations'

export const HeaderStyled = styled.header({
  padding: `1rem ${spacing.sm}`,
  backgroundColor: hexColors.blueDiamond,
  color: hexColors.white,
  fontSize: '1.2rem',
})

export const QuickbetBodyStyled = styled.div({
  padding: `1.5rem ${spacing.sm} 0rem ${spacing.sm}`,
  background: hexColors.whiteSmoke,
  minHeight: '13rem',
  overflow: 'auto',
})

export const QuickbetActionsStyled = styled.footer({
  boxSizing: 'border-box',
  position: 'relative',
  width: '100%',
  padding: spacing.sm,
})
